<template>
  <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.3833 0.302436C22.9767 -0.0473654 22.3382 -0.0974155 21.678 0.171535H21.6769C20.9825 0.454236 2.02124 8.70646 1.24934 9.04361C1.10895 9.09311 -0.117189 9.55731 0.00911141 10.5913C0.12186 11.5236 1.10732 11.9097 1.22766 11.9542L6.0482 13.629C6.36802 14.7092 7.547 18.6945 7.80773 19.5459C7.97034 20.0766 8.23541 20.774 8.69996 20.9176C9.10759 21.0771 9.51305 20.9313 9.7754 20.7223L12.7226 17.9487L17.4802 21.7135L17.5935 21.7822C17.9166 21.9274 18.2261 22 18.5215 22C18.7497 22 18.9687 21.9566 19.178 21.8697C19.8908 21.5727 20.1759 20.8835 20.2057 20.8054L23.7595 2.06299C23.9763 1.06199 23.6749 0.552686 23.3833 0.302436ZM10.2996 14.2989L8.6734 18.6989L7.04722 13.1989L19.5146 3.84885L10.2996 14.2989Z" fill="#00072F"/>
  </svg>
</template>

<script>
export default {
  name: 'TelegramIcon'
}
</script>



// WEBPACK FOOTER //
// src/components/icons/TelegramIcon.vue